import { z } from "zod";

export const StageSchema = z.object({
    id: z.number().positive().min(1),
    stageTypeId: z.number().positive().min(1),
    stageType: z.string().max(128),
    stageTypeLabel: z.string().max(128),
    stageOrder: z.number().positive().min(1),
    procedureId: z.number().positive().min(1),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    startDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    endDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    deleted: z.boolean(),
    closed: z.boolean(),
    opened: z.boolean(),
});

export type Stage = z.infer<typeof StageSchema>;
